/*
	@desc  6.5.6及以上版本才可以用。否则有bug
*/
import wxBridge from '../jsbridge/jsbridge_base.js';

import env from '../common/env.js';

wxBridge.downloadAppInternal = wxBridge.downloadAppInternal || function(param, callback) {
	param = param || {};
	
	var clientversion = env.clientVersion(true);
	
	if (env.versionCompare(clientversion, '6.5.6') >= 0) {
		
		wxBridge.invoke('downloadAppInternal', param, callback);
	} else {
		callback && callback.call(wxBridge,{});
		window.location.href = param.appUrl;
	}
};

export default wxBridge;

export const {
    downloadAppInternal
} = wxBridge;
